import React, { useState } from "react";
import emailjs from '@emailjs/browser'; // Import EmailJS
import "./GameRecomEmail.css"; // Import the CSS file

const GameRecomEmail = () => {
  const [email, setEmail] = useState(""); // Holds the email input value
  const [suggestion, setSuggestion] = useState(""); // Holds the suggestion input value
  const [messageSent, setMessageSent] = useState(false); // Tracks if the message is sent

  const handleSubmit = (e) => {
    e.preventDefault();

    // Log values for debugging
    console.log("Form submitted:", email, suggestion);

    // Initialize EmailJS with your public key
    emailjs.init('zpMGwg5cVWxmepkFu'); // Public Key

    const templateParams = {
      from_name: email, // Sender's email address
      to_name: "Chibi Dash", // Receiver's name (static value in this case)
      suggestion: suggestion, // User's suggestion
      email: email, // The user's email address
      message: suggestion, // The content of the user's suggestion
    };

    // Send email via EmailJS
    emailjs
      .send(
        "service_rt0v4ms", // Service ID
        "template_7gic9k6", // Template ID
        templateParams, // The parameters to be passed to the email template
        "zpMGwg5cVWxmepkFu" // Public Key
      )
      .then(
        (result) => {
          console.log(result.text); // Log success
          setMessageSent(true); // Show confirmation message
          setEmail(""); // Reset email field
          setSuggestion(""); // Reset suggestion field
        },
        (error) => {
          console.error(error.text); // Log any errors
        }
      );
  };

  return (
    <div className="game-recom-container">
      <h3>Which anime would you love to add to the guessing challenge?</h3>
      <form onSubmit={handleSubmit} className="game-recom-form">
        <input
          type="email"
          name="email" // Ensure the name attribute is 'email' for the EmailJS template
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Your email here..."
          required
        />
        <input
          type="text"
          name="suggestion" // Ensure the name attribute is 'suggestion' for the EmailJS template
          value={suggestion}
          onChange={(e) => setSuggestion(e.target.value)}
          placeholder="Suggest anime (add as many as you like)..."
          required
        />
        <button type="submit">SEND</button>
      </form>
      {messageSent && (
        <div className="thank-you-message">
          <p>✨ Thanks for your ideas! ✨</p>
        </div>
      )}
    </div>
  );
};

export default GameRecomEmail;
